// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/icons/play-control.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.post-detail__comments__actions__popover {
    padding: var(--space-and-half) var(--space);
}
.post-detail__comments__actions__popover__action {    
    width: 100%;
}

.post-detail__comments__container__comment__info__button {
    width: var(--space-and-half);
    height: var(--space-and-half);  
    position: absolute;
    right: 0px;
    
}
.post-detail__comments__container__comment__info__button:hover {
    cursor: pointer;
}

.post-detail__comments__container__comment__info__button__list {
    box-shadow: 2px 2px 5px 2px #4444;
    padding: 0;
    /* width: 15%; */
    margin-top: 0;
    /* list-style: none; */
    position: absolute;
}
.post-detail__comments__container__comment__info__button__list__item {
    display: flex;
    background-color: var(--white-color);
    padding: 10px 15px;    
    /* width: 100%; */
    /* outline: none; */
    align-items: center;
}

/* .post-detail__comments__container__comment__info__button__actions {
    max-width: var(--space-and-half);
    max-height: var(--space-and-half);
    box-sizing: content-box;
    border-radius: 2px;
    overflow: hidden;
} */
/* .post-detail__comments__container__comment__info__button__actions img {
    width: 90%;
} */
/* .post-detail__comments__container__comment__info__button__actions__popover {
    padding: var(--space-and-half) var(--space);
}
.post-detail__comments__container__comment__info__button__actions__popover__action {
    margin-bottom: var(--space-half);
    width: 100%;
} */


.post-detail {
    margin: 0 var(--space-x3);
    display: grid;
    grid-template-areas: "left left left center center center center center center right right right";
    grid-template-columns: repeat(12, 1fr);
    gap: var(--space-and-half);
    padding-bottom: var(--space-x3);
}

.post-detail__left-container {
    grid-area: left;
}

.post-detail__right-container {
    grid-area: right;
}
.post-detail__right-container__title {
    margin-top: var(--space-x3);
}
.post-detail__right-container__subtitle {
    margin-top: var(--space-x2);
}
.post-detail__right-container__post-detail-suggestions {
    margin-top: var(--space-x2);
}
.post-detail__right-container__pages-suggestions {
    margin-top: var(--space-x2);
}

.post-detail__center-container {
    grid-area: center;
    background: var(--white-color);
    box-shadow: 0px 3.02431px 3.02431px rgba(170, 193, 182, 0.32);
    border-radius: 11px;
    margin-top: var(--space);
}

/* .post-detail__content {
    margin-top: var(--space-x2-and-half);
} */
.post-detail__content__header{    
    display: flex;
    align-items: center;
    padding: 0 var(--space);
}
.post-detail__content__header__photo {
    /* width: var(--space-x2);
    height: var(--space-x2); */
    width: calc(var(--space)*2.2);
    height: calc(var(--space)*2.2);
    margin-right: var(--space-half);
    border-radius: 2px;
    overflow: hidden;
    background: var(--primary-light-color);
    padding: 0;
}
.post-detail__content__header__photo.no-photo {
    padding: var(--space-quarter);
}
.post-detail__content__header__photo img {
    width: 100%;
}
.post-detail__content__header__info {}
.post-detail__content__header__info__name {}
.post-detail__content__header__info__username {}
.post-detail__content__media {
    margin: var(--space) 0;
}

.post-detail__header {
    display: flex;
    padding: var(--space);
    align-items: center;
}
.post-detail__header__group{
    display: flex;
    padding-top: var(--space-half);
    padding-bottom: var(--space-quarter);
    padding-right: var(--space);
    padding-left: var(--space);
    align-items: center;
}
.post-detail__header__group-photo {
    width: var(--space);
    height: var(--space);
    min-width: var(--space);
    min-height: var(--space);
    position: relative;
    border-radius: 2px;
    overflow: hidden;
    margin-right: var(--space-half);
    background: var(--primary-light-color);
}
.post-detail__header__group-photo:hover {
    cursor: pointer;
}
.post-detail__header__group-photo img {
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.post-detail__header__photo {
    width: calc(var(--space-and-half) + var(--space-eighth) + calc(5px * 2));
    height: calc(var(--space-and-half) + var(--space-eighth) + calc(5px * 2));
    min-width: var(--space-x2);
    min-height: var(--space-x2);
    position: relative;
    border-radius: 50%;

    margin-right: var(--space);

}
.post-detail__header__photo:hover {
    cursor: pointer;
}
.post-detail__header__photo img {
    width: 100%;
    height: 100%;
    border-radius: inherit;
}

.post-detail__header__photo .icon-ball {
    font-size: calc(var(--space-and-half) + var(--space-eighth));/*26px*/
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 5px;
    height: calc(var(--space-and-half) + var(--space-eighth) + calc(5px * 2));
    color: var(--white-color);
}

.post-detail__header__photo.icon-ball {
    font-size: calc(var(--space-and-half) + var(--space-eighth));/*26px*/
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 5px;
    height: calc(var(--space-and-half) + var(--space-eighth) + calc(5px * 2));
    color: var(--white-color);
}
.post-detail__comments__container__comment__photo .icon-ball {
    font-size: calc(var(--space-and-half) + var(--space-eighth));/*26px*/
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 5px;
    height: calc(var(--space-and-half) + var(--space-eighth) + calc(5px * 2));
    color: var(--white-color);
    margin-right: var(--space-half);
}

.post-detail__header__info {
    max-height: var(--space-x2);
    flex-grow: 1;
}
.post-detail__header__info__group-username.baloa-caption {
    color: var(--primary-dark-color) !important;
}
.post-detail__header__info__username:hover {
    cursor: pointer;
}
.post-detail__header__info__username.baloa-normal-medium{
    color: var(--primary-dark-color);
}
.post-detail__header__info__username.baloa-normal-medium::first-letter{
    text-transform: uppercase;
}
.post-detail__header__info__username .iconb2-Verificated{
    font-size: var(--space); 
    margin-left: var(--space-half);   
}
.post-detail__header__info__username__follow-link.baloa-hyperlink{
    color: var(--new-green-color);
}
.post-detail__header__info__date.baloa-table-column {
    color: var(--basic-gray-color)
}
.post-detail__header__info__date.baloa-table-column::first-letter{
    text-transform: uppercase;
}
.post-detail__header__options {
    display: flex;
    margin-left: var(--space);
}
.post-detail__header__options__option {
    width: var(--space-and-half);
    height: var(--space-and-half);
    display: flex;
    justify-content: center;
    align-items: center;
}
.post-detail__header__options__option img {
    width: 100%;
    height: 100%;
}
.post-detail__header__options__option:hover {
    cursor: pointer;
}
.post-detail__header__options__option__list {
    margin-top: calc(var(--space-x3)*3.5);
    margin-right: calc(var(--space-x3)*4);
    width: calc(var(--space-x3)*5);
    list-style: none;
    position: absolute;
    z-index: 1;
    background: var(--white-color);
    box-shadow: 0px 0.470693px 16.4742px rgba(116, 116, 116, 0.25);
    border-radius: 5px;
    padding: 0;
}
.post-detail__header__options__option__list li{
    display: flex;
    justify-content: flex-start;
}
.post-detail__header__options__option__list__button {
    padding-top: calc(var(--space-half-quarter) + var(--space-eighth));/*14px*/
    padding-bottom: calc(var(--space-half-quarter) + var(--space-eighth));/*14px*/
    padding-left: calc(var(--space) + var(--space-quarter));/* 20px */;
    padding-right: calc( var(--space-x2) - var(--space-eighth) );/* 30px */
}

.text-button.post-detail__header__options__option__list__button:hover{
    background-color: transparent;
}
.post-detail__header__options__option__list__color {
    color: var(--new-text-link-color) !important;
    margin:0 !important;
}
span.post-detail__header__options__option__list__color.baloa-table-column{
    text-transform: none;
    display: flex;
    align-items: center;
}
.post-detail__header__options__option__list__color .iconb2-report, 
.post-detail__header__options__option__list__color .iconb2-block,
.post-detail__header__options__option__list__color .icon-edit-82,
.post-detail__header__options__option__list__color .icon-trash{
    font-size: calc(var(--space-and-half));
    margin-right: 10px;
}
.post-detail__header__options__option__list__popover {
    width: calc(var(--space-x3)*5);
    background: var(--white-color);
    box-shadow: 0px 0.470693px 16.4742px rgba(116, 116, 116, 0.25);
    border-radius: 5px;
}



.post-detail__content__media__video {
    position: relative;
    height: 500px;
    background-color: var(--black-color);
}
.post-detail__content__media img {
    width: 100%;
}
.post-detail__content__media video {
    width: 100%;
}
.post-detail__content__media__video__control {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}
.post-detail__content__media__video__control__background {
    background-color: black;
    opacity: 0.2;
    width: 100%;
    height: 100%;
}
.post-detail__content__media__video__control__icon {
    color: var(--secondary-color);
    position: absolute;
    /* background-color: rgba(77, 84, 81, 0.5); */
    font-size: calc(var(--space-x3)*1.3);
    text-align: center;
    width: calc(var(--space-x2)*2);
    height: calc(var(--space-x2)*2);
    padding-right: 2px;
    padding-top: 1px;
    padding-bottom: 2px;
    border-radius: 4px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    position: absolute;
    background-repeat: no-repeat;
    background-size: contain;
}
.post-detail__content__control-mute{
    position: absolute;
    bottom: 2%;
    right: 1%;
}
.post-detail__content__control-mute__icon {
    color: var(--secondary-color);
    font-size: var(--space-x2);
    background-color: rgba(77, 84, 81, 0.5);
    text-align: center;
    width: calc(var(--space-x2)*1.5);
    height: calc(var(--space-x2)*1.5);
    border-radius: 3px;
}
.post-detail__content__caption {
    display: flex;
    align-items: flex-start;
}
.post-detail__content__caption__photo {
    min-width: var(--space-and-half);
    min-height: var(--space-and-half);
    width: var(--space-and-half);
    height: var(--space-and-half);
    margin-right: var(--space-half-quarter);
    border-radius: 2px;
    overflow: hidden;
    background: var(--primary-light-color);
    padding: 0;
}
.post-detail__content__caption__photo.no-photo {
    padding: var(--space-quarter);
}
.post-detail__content__caption__photo img {
    width: 100%;
}
.post-detail__content__caption__info {
    padding: 0 var(--space);
}
.post-detail__content__caption__info__name {
    font-family: var(--secondary-font) !important;
    font-style: normal;
    font-weight: var(--font-bold) !important;
    font-size: var(--space) !important;
    line-height: var(--space-and-half) !important;
    display: flex;
    align-items: center;
    letter-spacing: 0.005em;
    color: var(--primary-dark-color) !important;
}
.post-detail__content__caption__info__caption.baloa-normal {
    color: var(--primary-very-dark-color);
    text-align: justify;
    display: inline-block;
    word-break: break-all;
    padding-bottom: var(--space);
}
.post-detail__content__caption__info__caption.baloa-names {
    color: var(--new-green-color);
    cursor: pointer;
    padding-left: 0;
    padding-bottom: 0;
}
.post-detail__content__actions {
    display: flex;
    padding: var(--space);
    padding-bottom: var(--space-half-quarter);
    padding-top: var(--space-half-quarter);
    justify-content: space-between;
}
.post-detail__content__actions__action {
    margin-right: var(--space);
}
.post-detail__content__actions__action:hover {
    cursor: pointer;
}
.post-detail__clapped-by {
    padding: var(--space-half-quarter) var(--space);    
    display: flex;
}
.post-detail__clapped-by__photos {
    display: flex;
    align-items: center;
}
.post-detail__clapped-by__photos__photo {
    width: var(--space-and-half);
    height: var(--space-and-half);
    min-width: var(--space-and-half);
    min-height: var(--space-and-half);
    max-width: var(--space-and-half);
    max-height: var(--space-and-half);
    border-radius: 50%;
    overflow: hidden;
    background: var(--basic-gray-color);
    display: flex;
    justify-content: center;
    align-items: center;
}
.post-detail__clapped-by__photos__photo img {
    width: var(--space-and-half);
    height: var(--space-and-half);
    border-radius: 50%;
}
.post-detail__clapped-by__photos__photo .icon-ball{
    font-size: calc(var(--space) + var(--space-quarter));/*20px*/
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 2px;
    height: var(--space-and-half);
    color: var(--white-color);
}
.post-detail__clapped-by__message {
    margin-left: var(--space);
    display: flex;
    align-items: center;
}
.post-detail__clapped-by__message .baloa-normal{
    color: var(--primary-very-dark-color);
}

.post-detail__clapped-by__message span {}

.post-detail__content__new-comment__comment{  
    padding-right: var(--space);
    padding-left: var(--space);
    padding-top: var(--space);
    padding-bottom: var(--space-and-half);
    display: flex;
    align-items: center;
}
.post-detail__content__new-comment__comment_list .MuiList-padding {
    padding-top: 0;
    padding-bottom: 0;
}

.post-detail__content__new-comment__comment_list .icon-ball{
    font-size: calc(var(--space-and-half) + var(--space-eighth));/*26px*/
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 5px;
    height: calc(var(--space-and-half) + var(--space-eighth) + calc(5px * 2));
    color: var(--white-color);
}
.post-detail__content__new-comment__comment_list .MuiAvatar-colorDefault{
    background: none;
}
.post-detail__content__new-comment__comment_list .MuiListItem-gutters{
    padding-left: 0;
}

.post-detail__content__new-comment {   
    width: 200%;
}

.post-detail__content__reply-comment{
    margin-top: var(--space-half-quarter);
    width: 100%;
}

.post-detail__comments {        
    padding-left: var(--space);
    padding-right: var(--space);
}
p.post-detail__comments__title {
    color: var(--basic-gray-color) !important;
}
.post-detail__comments__container {
    position: relative;
}

.post-detail__comments__container__comment {
    display: flex;
    /* padding-bottom: var(--space-x2); */ 
}
/* .post-detail__comments__container__comment__photo {
    min-width: calc(var(--space-x2) + var(--space-quarter));
    min-height: calc(var(--space-x2) + var(--space-quarter));
    width: calc(var(--space-x2) + var(--space-quarter));
    height: calc(var(--space-x2) + var(--space-quarter));
    margin-right: var(--space-half);
    border-radius: 50%;
    overflow: hidden;
    background: var(--primary-light-color);
    padding: 0;
}
.post-detail__comments__container__comment__photo.no-photo {
    padding: var(--space-quarter);
} */
.post-detail__comments__container__comment__photo img {
    min-width: calc(var(--space-x2) + var(--space-quarter));
    min-height: calc(var(--space-x2) + var(--space-quarter));
    width: calc(var(--space-x2) + var(--space-quarter));
    height: calc(var(--space-x2) + var(--space-quarter));
    border-radius: 50%;
    margin-right: var(--space-half);
}
.post-detail__comments__container__comment__info {
    width: 100%;
}
.post-detail__comments__container__comment__info__name {
    font-family: var(--secondary-font) !important;
    font-style: normal !important;
    font-weight: var(--font-bold) !important;
    font-size: var(--space) !important;
    line-height: var(--space-and-half) !important;
    display: flex;
    align-items: center;
    letter-spacing: 0.005em;
    color: var(--primary-dark-color) !important;
}
.post-detail__comments__container__comment__info__caption {
    color: var(--primary-very-dark-color) !important;
    word-break: break-all;
}
.post-detail__comments__container__comment__info__caption span {
    color: var(--primary-very-dark-color);
}
.post-detail__comments__container__comment__info__caption__author {
    color: var(--primary-very-dark-color) !important;
}
.post-detail__comments__container__comment__info__actions {
    align-items: center;
    margin-top: 5px;
    flex-wrap: wrap;
    padding-bottom: var(--space-half-quarter);
}
.post-detail__comments__container__comment__info__action {
    display: flex;
    align-items: center;
}

.post-detail__comments__container__comment__info__action__reply-comment__icon{
    margin-left: var(--space-half);
    cursor: pointer;

}
.post-detail__comments__container__comment__info__action__reply-comment__icon.baloa-names{
    color: var(--primary-very-dark-color);
}

.post-detail__comments__container__comment__info__clapped-by {
    display: flex;
    margin-left: var(--space-half);
}

.post-detail__comments__container__comment__info__clapped-by__message {
    display: flex;
    align-items: center;
}
/* .post-detail__content__new-comment__input{
    border: 2px solid var(--mid-gray-color) !important;
} */

.post-detail__comments__container__reply-comment__info__name{
    font-size: var(--font-normal);
    font-weight: var(--font-bold) !important;
}

.post-detail__comments__container__reply-comment__info__caption{
    color: var(--primary-very-dark-color) !important;
}

.post-detail__comments__container__reply-comment__info__caption__author{    
    color: var(--primary-very-dark-color) !important;
}

.post-detail__comments__container__reply-comment__info__caption span{
    /*font-weight: var(--font-bold);*/
    color: var(--primary-very-dark-color);
}

.post-detail__comments__container__reply-comment-icon{
    color: var(--primary-dark-color);
    cursor: pointer;
    
}

/* .post-detail__content__reply-comment__input{
    border: 2px solid var(--mid-gray-color) !important;
    margin-left: var(--space-x2);
} */

.post-detail__comments__container__comment__info__clapped-by__message span {}

@media screen and ( max-width: 768px ) {

    .post-detail {
        margin: 0;
        /* margin-top: var(--space); */
        grid-template-areas: "left"
                             "center";
        grid-template-columns: 100%;
        gap: var(--space-half);
    }

}

.MuiPopover-root.post-detail__actions__action__menu-reactions .MuiListItem-root{
    display: inline;
}

.MuiPopover-root.post-detail__actions__action__menu-reactions .MuiPaper-rounded{
    border-radius: 34px;
    padding-left: var(--space-half);
    padding-right: var(--space-half);
}

.post-detail__actions__action__menu-reactions__icon{
    font-size: var(--space-x3);
    border-radius: 50%;
}

.post-detail__actions__action__menu-reactions__icon:hover{
    font-size: calc(var(--space-x3) + var(--space-and-half));
}

.MuiPopover-root.post-detail__actions__action__menu-reactions .MuiListItem-gutters{
    padding-left: var(--space-quarter);
    padding-right: var(--space-quarter);
    background: transparent;
}

.post-detail__actions__action__reactions__icon{
    font-size: var(--space-x2);
    margin-right: var(--space-half-quarter);
}
.post-detail__actions__action__comment-reactions__icon{
    font-size: var(--space-and-half);
    margin-right: var(--space-half-quarter);
}

.post-detail__actions__action__reaction-green.baloa-normal-medium{
    color: #30B36B !important;
    letter-spacing: 0 !important;
    display: flex;
    align-items: center;
}

.post-detail__actions__action__reaction-yellow.baloa-normal-medium{
    color: #EECA35 !important;
    letter-spacing: 0 !important;
    display: flex;
    align-items: center;
} 

.post-detail__actions__action__reaction-red.baloa-normal-medium{
    color: #EB3B3B !important;
    letter-spacing: 0 !important;
    display: flex;
    align-items: center;
}
.post-detail__actions__action__reaction-green.baloa-table-column{
    color: #30B36B !important;
    letter-spacing: 0 !important;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.post-detail__actions__action__reaction-yellow.baloa-table-column{
    color: #EECA35 !important;
    letter-spacing: 0 !important;
    display: flex;
    align-items: center;
    cursor: pointer;
} 

.post-detail__actions__action__reaction-red.baloa-table-column{
    color: #EB3B3B !important;
    letter-spacing: 0 !important;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.post-detail__actions__action{
    display: flex;
    align-items: center;    
}

.post-detail__actions__action .baloa-table-column{
    color: var(--primary-dark-color);
    cursor: pointer;
}
.post-detail__actions__action .icon-share, .post-detail__actions__action .icon-message, .post-detail__actions__action .icon-claps-48{
    color: var(--primary-dark-color);
    font-size: var(--space-and-half);
    margin-right: var(--space-half-quarter);
    cursor: pointer;
}
.post-detail__actions__action__action-text.baloa-normal-medium{
    color: var(--primary-dark-color);
}

.post-detail__actions__action__list {
    box-shadow: 2px 2px 5px 2px #4444;
    padding: 0;
    /* width: 15%; */
    margin-top: calc(-1* calc(var(--space-x3)*2.2));
    list-style: none;
    position: absolute;
    border-radius: 20px;
}
 
.post-detail__actions__action__list__button {
    display: flex;
    background-color: var(--white-color);
    font-size: var(--space);
    padding: var(--space-half-quarter) var(--space-and-half);
    border: 0;
    width: 100%;
    outline: none;
    cursor: pointer;
    align-items: center;
    border-radius: 20px;
}

.post-detail__actions__action__list__button:hover {
    background-color: var(--primary-light-color);
}
.post-detail__separator{
    border-top: 1px solid var(--separator-color);
}

.post-detail__comments__container__comment__info__resume{
    width: 100%;
    padding-top: var(--space-half-quarter);
    padding-bottom: var(--space-half-quarter);
    cursor: pointer;
    align-items: center;
}
.post-detail__comments__container__comment__info__resume.baloa-names{
    color: var(--primary-dark-color);   
    display: flex;
    justify-content: flex-start; 
}
.post-detail__comments__container__comment-of-comment{
    display: flex;
    padding-bottom: var(--space);
}

.post-detail__comments__container__comment__info__resume__line-answers hr{
    height:2px;
    border-width:0;
    color:#C5C5C5;
    background-color:#C5C5C5;
    width: var(--space-x2);
    margin-right: var(--space-half);
}

@media screen and ( max-width: 375px ) {
    .post-detail__header__info {
        max-height: none;
        flex-grow: 1;
    }
    .post-detail__header__photo{
        height: auto;
    }
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .post-detail {
        margin: 0 var(--space) var(--space) var(--space);
    }

    .post-detail__actions__action{
        flex-direction: column;
    }

    .post-detail__header__info__username__follow-link.baloa-hyperlink.mobile{
        color: var(--basic-gray-color);
    }

    .post-detail__content__media{
        margin:0;
    }
    .post-detail__actions__action .icon-share, .post-detail__actions__action .icon-message, .post-detail__actions__action .icon-claps-48 {
        margin-right: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/posts/views/post-detail/PostDetailView.styles.css"],"names":[],"mappings":";;AAEA;IACI,2CAA2C;AAC/C;AACA;IACI,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,kBAAkB;IAClB,UAAU;;AAEd;AACA;IACI,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,oCAAoC;IACpC,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;;;;;GAMG;AACH;;GAEG;AACH;;;;;;GAMG;;;AAGH;IACI,yBAAyB;IACzB,aAAa;IACb,iGAAiG;IACjG,sCAAsC;IACtC,0BAA0B;IAC1B,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,6DAA6D;IAC7D,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;;GAEG;AACH;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI;8BAC0B;IAC1B,6BAA6B;IAC7B,8BAA8B;IAC9B,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,sCAAsC;IACtC,UAAU;AACd;AACA;IACI,6BAA6B;AACjC;AACA;IACI,WAAW;AACf;AACA,qCAAqC;AACrC,2CAA2C;AAC3C,+CAA+C;AAC/C;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,oCAAoC;IACpC,2BAA2B;IAC3B,0BAA0B;IAC1B,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,sCAAsC;AAC1C;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;AACZ;AACA;IACI,wEAAwE;IACxE,yEAAyE;IACzE,0BAA0B;IAC1B,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;;IAElB,0BAA0B;;AAE9B;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,4DAA4D,CAAC,OAAO;IACpE,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yEAAyE;IACzE,yBAAyB;AAC7B;;AAEA;IACI,4DAA4D,CAAC,OAAO;IACpE,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yEAAyE;IACzE,yBAAyB;AAC7B;AACA;IACI,4DAA4D,CAAC,OAAO;IACpE,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yEAAyE;IACzE,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,eAAe;AACnB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,uBAAuB;IACvB,8BAA8B;AAClC;AACA;IACI,6BAA6B;AACjC;AACA;IACI;AACJ;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;AACnB;AACA;IACI,qCAAqC;IACrC,qCAAqC;IACrC,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,8BAA8B;IAC9B,8DAA8D;IAC9D,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,aAAa;IACb,2BAA2B;AAC/B;AACA;IACI,kEAAkE,CAAC,OAAO;IAC1E,qEAAqE,CAAC,OAAO;IAC7E,uDAAuD,CAAC,SAAS;IACjE,4DAA4D,CAAC,SAAS;AAC1E;;AAEA;IACI,6BAA6B;AACjC;AACA;IACI,4CAA4C;IAC5C,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,aAAa;IACb,mBAAmB;AACvB;AACA;;;;IAII,sCAAsC;IACtC,kBAAkB;AACtB;AACA;IACI,8BAA8B;IAC9B,8BAA8B;IAC9B,8DAA8D;IAC9D,kBAAkB;AACtB;;;;AAIA;IACI,kBAAkB;IAClB,aAAa;IACb,oCAAoC;AACxC;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;AACA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,6CAA6C;IAC7C,oCAAoC;IACpC,kBAAkB;IAClB,8BAA8B;IAC9B,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,yDAAkE;IAClE,kBAAkB;IAClB,4BAA4B;IAC5B,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;AACA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,uCAAuC;IACvC,kBAAkB;IAClB,gCAAgC;IAChC,iCAAiC;IACjC,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,gCAAgC;IAChC,iCAAiC;IACjC,4BAA4B;IAC5B,6BAA6B;IAC7B,uCAAuC;IACvC,kBAAkB;IAClB,gBAAgB;IAChB,sCAAsC;IACtC,UAAU;AACd;AACA;IACI,6BAA6B;AACjC;AACA;IACI,WAAW;AACf;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,wCAAwC;IACxC,kCAAkC;IAClC,6CAA6C;IAC7C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2CAA2C;AAC/C;AACA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,4BAA4B;AAChC;AACA;IACI,6BAA6B;IAC7B,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,yCAAyC;IACzC,sCAAsC;IACtC,8BAA8B;AAClC;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,eAAe;AACnB;AACA;IACI,+CAA+C;IAC/C,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,gCAAgC;IAChC,iCAAiC;IACjC,gCAAgC;IAChC,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,mCAAmC;IACnC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,kBAAkB;AACtB;AACA;IACI,oDAAoD,CAAC,OAAO;IAC5D,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,qCAAqC;AACzC;;AAEA,wCAAwC;;AAExC;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,yBAAyB;IACzB,qCAAqC;IACrC,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,4DAA4D,CAAC,OAAO;IACpE,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yEAAyE;IACzE,yBAAyB;AAC7B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qCAAqC;AACzC;AACA;;;;;;;;;;;;;GAaG;AACH;IACI,uDAAuD;IACvD,wDAAwD;IACxD,mDAAmD;IACnD,oDAAoD;IACpD,kBAAkB;IAClB,+BAA+B;AACnC;AACA;IACI,WAAW;AACf;AACA;IACI,6CAA6C;IAC7C,6BAA6B;IAC7B,wCAAwC;IACxC,kCAAkC;IAClC,6CAA6C;IAC7C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2CAA2C;AAC/C;AACA;IACI,gDAAgD;IAChD,qBAAqB;AACzB;AACA;IACI,qCAAqC;AACzC;AACA;IACI,gDAAgD;AACpD;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,yCAAyC;AAC7C;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;;AAEnB;AACA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;;GAEG;;AAEH;IACI,6BAA6B;IAC7B,wCAAwC;AAC5C;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,iCAAiC;IACjC,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;IAChC,eAAe;;AAEnB;;AAEA;;;GAGG;;AAEH,4EAA4E;;AAE5E;;IAEI;QACI,SAAS;QACT,8BAA8B;QAC9B;qCAC6B;QAC7B,2BAA2B;QAC3B,sBAAsB;IAC1B;;AAEJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,uCAAuC;AAC3C;AACA;IACI,gCAAgC;IAChC,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,eAAe;AACnB;AACA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,uCAAuC;IACvC,eAAe;AACnB;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;IACjC,UAAU;IACV,gBAAgB;IAChB,+CAA+C;IAC/C,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,uBAAuB;IACvB,wDAAwD;IACxD,SAAS;IACT,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,4CAA4C;AAChD;AACA;IACI,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,sCAAsC;IACtC,yCAAyC;IACzC,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,gCAAgC;IAChC,aAAa;IACb,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,cAAc;IACd,aAAa;IACb,wBAAwB;IACxB,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,gDAAgD;IACpD;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,QAAQ;IACZ;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":["\n\n.post-detail__comments__actions__popover {\n    padding: var(--space-and-half) var(--space);\n}\n.post-detail__comments__actions__popover__action {    \n    width: 100%;\n}\n\n.post-detail__comments__container__comment__info__button {\n    width: var(--space-and-half);\n    height: var(--space-and-half);  \n    position: absolute;\n    right: 0px;\n    \n}\n.post-detail__comments__container__comment__info__button:hover {\n    cursor: pointer;\n}\n\n.post-detail__comments__container__comment__info__button__list {\n    box-shadow: 2px 2px 5px 2px #4444;\n    padding: 0;\n    /* width: 15%; */\n    margin-top: 0;\n    /* list-style: none; */\n    position: absolute;\n}\n.post-detail__comments__container__comment__info__button__list__item {\n    display: flex;\n    background-color: var(--white-color);\n    padding: 10px 15px;    \n    /* width: 100%; */\n    /* outline: none; */\n    align-items: center;\n}\n\n/* .post-detail__comments__container__comment__info__button__actions {\n    max-width: var(--space-and-half);\n    max-height: var(--space-and-half);\n    box-sizing: content-box;\n    border-radius: 2px;\n    overflow: hidden;\n} */\n/* .post-detail__comments__container__comment__info__button__actions img {\n    width: 90%;\n} */\n/* .post-detail__comments__container__comment__info__button__actions__popover {\n    padding: var(--space-and-half) var(--space);\n}\n.post-detail__comments__container__comment__info__button__actions__popover__action {\n    margin-bottom: var(--space-half);\n    width: 100%;\n} */\n\n\n.post-detail {\n    margin: 0 var(--space-x3);\n    display: grid;\n    grid-template-areas: \"left left left center center center center center center right right right\";\n    grid-template-columns: repeat(12, 1fr);\n    gap: var(--space-and-half);\n    padding-bottom: var(--space-x3);\n}\n\n.post-detail__left-container {\n    grid-area: left;\n}\n\n.post-detail__right-container {\n    grid-area: right;\n}\n.post-detail__right-container__title {\n    margin-top: var(--space-x3);\n}\n.post-detail__right-container__subtitle {\n    margin-top: var(--space-x2);\n}\n.post-detail__right-container__post-detail-suggestions {\n    margin-top: var(--space-x2);\n}\n.post-detail__right-container__pages-suggestions {\n    margin-top: var(--space-x2);\n}\n\n.post-detail__center-container {\n    grid-area: center;\n    background: var(--white-color);\n    box-shadow: 0px 3.02431px 3.02431px rgba(170, 193, 182, 0.32);\n    border-radius: 11px;\n    margin-top: var(--space);\n}\n\n/* .post-detail__content {\n    margin-top: var(--space-x2-and-half);\n} */\n.post-detail__content__header{    \n    display: flex;\n    align-items: center;\n    padding: 0 var(--space);\n}\n.post-detail__content__header__photo {\n    /* width: var(--space-x2);\n    height: var(--space-x2); */\n    width: calc(var(--space)*2.2);\n    height: calc(var(--space)*2.2);\n    margin-right: var(--space-half);\n    border-radius: 2px;\n    overflow: hidden;\n    background: var(--primary-light-color);\n    padding: 0;\n}\n.post-detail__content__header__photo.no-photo {\n    padding: var(--space-quarter);\n}\n.post-detail__content__header__photo img {\n    width: 100%;\n}\n.post-detail__content__header__info {}\n.post-detail__content__header__info__name {}\n.post-detail__content__header__info__username {}\n.post-detail__content__media {\n    margin: var(--space) 0;\n}\n\n.post-detail__header {\n    display: flex;\n    padding: var(--space);\n    align-items: center;\n}\n.post-detail__header__group{\n    display: flex;\n    padding-top: var(--space-half);\n    padding-bottom: var(--space-quarter);\n    padding-right: var(--space);\n    padding-left: var(--space);\n    align-items: center;\n}\n.post-detail__header__group-photo {\n    width: var(--space);\n    height: var(--space);\n    min-width: var(--space);\n    min-height: var(--space);\n    position: relative;\n    border-radius: 2px;\n    overflow: hidden;\n    margin-right: var(--space-half);\n    background: var(--primary-light-color);\n}\n.post-detail__header__group-photo:hover {\n    cursor: pointer;\n}\n.post-detail__header__group-photo img {\n    width: 100%;\n    height: 100%;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n}\n.post-detail__header__photo {\n    width: calc(var(--space-and-half) + var(--space-eighth) + calc(5px * 2));\n    height: calc(var(--space-and-half) + var(--space-eighth) + calc(5px * 2));\n    min-width: var(--space-x2);\n    min-height: var(--space-x2);\n    position: relative;\n    border-radius: 50%;\n\n    margin-right: var(--space);\n\n}\n.post-detail__header__photo:hover {\n    cursor: pointer;\n}\n.post-detail__header__photo img {\n    width: 100%;\n    height: 100%;\n    border-radius: inherit;\n}\n\n.post-detail__header__photo .icon-ball {\n    font-size: calc(var(--space-and-half) + var(--space-eighth));/*26px*/\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 5px;\n    height: calc(var(--space-and-half) + var(--space-eighth) + calc(5px * 2));\n    color: var(--white-color);\n}\n\n.post-detail__header__photo.icon-ball {\n    font-size: calc(var(--space-and-half) + var(--space-eighth));/*26px*/\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 5px;\n    height: calc(var(--space-and-half) + var(--space-eighth) + calc(5px * 2));\n    color: var(--white-color);\n}\n.post-detail__comments__container__comment__photo .icon-ball {\n    font-size: calc(var(--space-and-half) + var(--space-eighth));/*26px*/\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 5px;\n    height: calc(var(--space-and-half) + var(--space-eighth) + calc(5px * 2));\n    color: var(--white-color);\n    margin-right: var(--space-half);\n}\n\n.post-detail__header__info {\n    max-height: var(--space-x2);\n    flex-grow: 1;\n}\n.post-detail__header__info__group-username.baloa-caption {\n    color: var(--primary-dark-color) !important;\n}\n.post-detail__header__info__username:hover {\n    cursor: pointer;\n}\n.post-detail__header__info__username.baloa-normal-medium{\n    color: var(--primary-dark-color);\n}\n.post-detail__header__info__username.baloa-normal-medium::first-letter{\n    text-transform: uppercase;\n}\n.post-detail__header__info__username .iconb2-Verificated{\n    font-size: var(--space); \n    margin-left: var(--space-half);   \n}\n.post-detail__header__info__username__follow-link.baloa-hyperlink{\n    color: var(--new-green-color);\n}\n.post-detail__header__info__date.baloa-table-column {\n    color: var(--basic-gray-color)\n}\n.post-detail__header__info__date.baloa-table-column::first-letter{\n    text-transform: uppercase;\n}\n.post-detail__header__options {\n    display: flex;\n    margin-left: var(--space);\n}\n.post-detail__header__options__option {\n    width: var(--space-and-half);\n    height: var(--space-and-half);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.post-detail__header__options__option img {\n    width: 100%;\n    height: 100%;\n}\n.post-detail__header__options__option:hover {\n    cursor: pointer;\n}\n.post-detail__header__options__option__list {\n    margin-top: calc(var(--space-x3)*3.5);\n    margin-right: calc(var(--space-x3)*4);\n    width: calc(var(--space-x3)*5);\n    list-style: none;\n    position: absolute;\n    z-index: 1;\n    background: var(--white-color);\n    box-shadow: 0px 0.470693px 16.4742px rgba(116, 116, 116, 0.25);\n    border-radius: 5px;\n    padding: 0;\n}\n.post-detail__header__options__option__list li{\n    display: flex;\n    justify-content: flex-start;\n}\n.post-detail__header__options__option__list__button {\n    padding-top: calc(var(--space-half-quarter) + var(--space-eighth));/*14px*/\n    padding-bottom: calc(var(--space-half-quarter) + var(--space-eighth));/*14px*/\n    padding-left: calc(var(--space) + var(--space-quarter));/* 20px */;\n    padding-right: calc( var(--space-x2) - var(--space-eighth) );/* 30px */\n}\n\n.text-button.post-detail__header__options__option__list__button:hover{\n    background-color: transparent;\n}\n.post-detail__header__options__option__list__color {\n    color: var(--new-text-link-color) !important;\n    margin:0 !important;\n}\nspan.post-detail__header__options__option__list__color.baloa-table-column{\n    text-transform: none;\n    display: flex;\n    align-items: center;\n}\n.post-detail__header__options__option__list__color .iconb2-report, \n.post-detail__header__options__option__list__color .iconb2-block,\n.post-detail__header__options__option__list__color .icon-edit-82,\n.post-detail__header__options__option__list__color .icon-trash{\n    font-size: calc(var(--space-and-half));\n    margin-right: 10px;\n}\n.post-detail__header__options__option__list__popover {\n    width: calc(var(--space-x3)*5);\n    background: var(--white-color);\n    box-shadow: 0px 0.470693px 16.4742px rgba(116, 116, 116, 0.25);\n    border-radius: 5px;\n}\n\n\n\n.post-detail__content__media__video {\n    position: relative;\n    height: 500px;\n    background-color: var(--black-color);\n}\n.post-detail__content__media img {\n    width: 100%;\n}\n.post-detail__content__media video {\n    width: 100%;\n}\n.post-detail__content__media__video__control {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.post-detail__content__media__video__control__background {\n    background-color: black;\n    opacity: 0.2;\n    width: 100%;\n    height: 100%;\n}\n.post-detail__content__media__video__control__icon {\n    color: var(--secondary-color);\n    position: absolute;\n    /* background-color: rgba(77, 84, 81, 0.5); */\n    font-size: calc(var(--space-x3)*1.3);\n    text-align: center;\n    width: calc(var(--space-x2)*2);\n    height: calc(var(--space-x2)*2);\n    padding-right: 2px;\n    padding-top: 1px;\n    padding-bottom: 2px;\n    border-radius: 4px;\n    background-image: url(\"../../../../assets/icons/play-control.png\");\n    position: absolute;\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n.post-detail__content__control-mute{\n    position: absolute;\n    bottom: 2%;\n    right: 1%;\n}\n.post-detail__content__control-mute__icon {\n    color: var(--secondary-color);\n    font-size: var(--space-x2);\n    background-color: rgba(77, 84, 81, 0.5);\n    text-align: center;\n    width: calc(var(--space-x2)*1.5);\n    height: calc(var(--space-x2)*1.5);\n    border-radius: 3px;\n}\n.post-detail__content__caption {\n    display: flex;\n    align-items: flex-start;\n}\n.post-detail__content__caption__photo {\n    min-width: var(--space-and-half);\n    min-height: var(--space-and-half);\n    width: var(--space-and-half);\n    height: var(--space-and-half);\n    margin-right: var(--space-half-quarter);\n    border-radius: 2px;\n    overflow: hidden;\n    background: var(--primary-light-color);\n    padding: 0;\n}\n.post-detail__content__caption__photo.no-photo {\n    padding: var(--space-quarter);\n}\n.post-detail__content__caption__photo img {\n    width: 100%;\n}\n.post-detail__content__caption__info {\n    padding: 0 var(--space);\n}\n.post-detail__content__caption__info__name {\n    font-family: var(--secondary-font) !important;\n    font-style: normal;\n    font-weight: var(--font-bold) !important;\n    font-size: var(--space) !important;\n    line-height: var(--space-and-half) !important;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.005em;\n    color: var(--primary-dark-color) !important;\n}\n.post-detail__content__caption__info__caption.baloa-normal {\n    color: var(--primary-very-dark-color);\n    text-align: justify;\n    display: inline-block;\n    word-break: break-all;\n    padding-bottom: var(--space);\n}\n.post-detail__content__caption__info__caption.baloa-names {\n    color: var(--new-green-color);\n    cursor: pointer;\n    padding-left: 0;\n    padding-bottom: 0;\n}\n.post-detail__content__actions {\n    display: flex;\n    padding: var(--space);\n    padding-bottom: var(--space-half-quarter);\n    padding-top: var(--space-half-quarter);\n    justify-content: space-between;\n}\n.post-detail__content__actions__action {\n    margin-right: var(--space);\n}\n.post-detail__content__actions__action:hover {\n    cursor: pointer;\n}\n.post-detail__clapped-by {\n    padding: var(--space-half-quarter) var(--space);    \n    display: flex;\n}\n.post-detail__clapped-by__photos {\n    display: flex;\n    align-items: center;\n}\n.post-detail__clapped-by__photos__photo {\n    width: var(--space-and-half);\n    height: var(--space-and-half);\n    min-width: var(--space-and-half);\n    min-height: var(--space-and-half);\n    max-width: var(--space-and-half);\n    max-height: var(--space-and-half);\n    border-radius: 50%;\n    overflow: hidden;\n    background: var(--basic-gray-color);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.post-detail__clapped-by__photos__photo img {\n    width: var(--space-and-half);\n    height: var(--space-and-half);\n    border-radius: 50%;\n}\n.post-detail__clapped-by__photos__photo .icon-ball{\n    font-size: calc(var(--space) + var(--space-quarter));/*20px*/\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 2px;\n    height: var(--space-and-half);\n    color: var(--white-color);\n}\n.post-detail__clapped-by__message {\n    margin-left: var(--space);\n    display: flex;\n    align-items: center;\n}\n.post-detail__clapped-by__message .baloa-normal{\n    color: var(--primary-very-dark-color);\n}\n\n.post-detail__clapped-by__message span {}\n\n.post-detail__content__new-comment__comment{  \n    padding-right: var(--space);\n    padding-left: var(--space);\n    padding-top: var(--space);\n    padding-bottom: var(--space-and-half);\n    display: flex;\n    align-items: center;\n}\n.post-detail__content__new-comment__comment_list .MuiList-padding {\n    padding-top: 0;\n    padding-bottom: 0;\n}\n\n.post-detail__content__new-comment__comment_list .icon-ball{\n    font-size: calc(var(--space-and-half) + var(--space-eighth));/*26px*/\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 5px;\n    height: calc(var(--space-and-half) + var(--space-eighth) + calc(5px * 2));\n    color: var(--white-color);\n}\n.post-detail__content__new-comment__comment_list .MuiAvatar-colorDefault{\n    background: none;\n}\n.post-detail__content__new-comment__comment_list .MuiListItem-gutters{\n    padding-left: 0;\n}\n\n.post-detail__content__new-comment {   \n    width: 200%;\n}\n\n.post-detail__content__reply-comment{\n    margin-top: var(--space-half-quarter);\n    width: 100%;\n}\n\n.post-detail__comments {        \n    padding-left: var(--space);\n    padding-right: var(--space);\n}\np.post-detail__comments__title {\n    color: var(--basic-gray-color) !important;\n}\n.post-detail__comments__container {\n    position: relative;\n}\n\n.post-detail__comments__container__comment {\n    display: flex;\n    /* padding-bottom: var(--space-x2); */ \n}\n/* .post-detail__comments__container__comment__photo {\n    min-width: calc(var(--space-x2) + var(--space-quarter));\n    min-height: calc(var(--space-x2) + var(--space-quarter));\n    width: calc(var(--space-x2) + var(--space-quarter));\n    height: calc(var(--space-x2) + var(--space-quarter));\n    margin-right: var(--space-half);\n    border-radius: 50%;\n    overflow: hidden;\n    background: var(--primary-light-color);\n    padding: 0;\n}\n.post-detail__comments__container__comment__photo.no-photo {\n    padding: var(--space-quarter);\n} */\n.post-detail__comments__container__comment__photo img {\n    min-width: calc(var(--space-x2) + var(--space-quarter));\n    min-height: calc(var(--space-x2) + var(--space-quarter));\n    width: calc(var(--space-x2) + var(--space-quarter));\n    height: calc(var(--space-x2) + var(--space-quarter));\n    border-radius: 50%;\n    margin-right: var(--space-half);\n}\n.post-detail__comments__container__comment__info {\n    width: 100%;\n}\n.post-detail__comments__container__comment__info__name {\n    font-family: var(--secondary-font) !important;\n    font-style: normal !important;\n    font-weight: var(--font-bold) !important;\n    font-size: var(--space) !important;\n    line-height: var(--space-and-half) !important;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.005em;\n    color: var(--primary-dark-color) !important;\n}\n.post-detail__comments__container__comment__info__caption {\n    color: var(--primary-very-dark-color) !important;\n    word-break: break-all;\n}\n.post-detail__comments__container__comment__info__caption span {\n    color: var(--primary-very-dark-color);\n}\n.post-detail__comments__container__comment__info__caption__author {\n    color: var(--primary-very-dark-color) !important;\n}\n.post-detail__comments__container__comment__info__actions {\n    align-items: center;\n    margin-top: 5px;\n    flex-wrap: wrap;\n    padding-bottom: var(--space-half-quarter);\n}\n.post-detail__comments__container__comment__info__action {\n    display: flex;\n    align-items: center;\n}\n\n.post-detail__comments__container__comment__info__action__reply-comment__icon{\n    margin-left: var(--space-half);\n    cursor: pointer;\n\n}\n.post-detail__comments__container__comment__info__action__reply-comment__icon.baloa-names{\n    color: var(--primary-very-dark-color);\n}\n\n.post-detail__comments__container__comment__info__clapped-by {\n    display: flex;\n    margin-left: var(--space-half);\n}\n\n.post-detail__comments__container__comment__info__clapped-by__message {\n    display: flex;\n    align-items: center;\n}\n/* .post-detail__content__new-comment__input{\n    border: 2px solid var(--mid-gray-color) !important;\n} */\n\n.post-detail__comments__container__reply-comment__info__name{\n    font-size: var(--font-normal);\n    font-weight: var(--font-bold) !important;\n}\n\n.post-detail__comments__container__reply-comment__info__caption{\n    color: var(--primary-very-dark-color) !important;\n}\n\n.post-detail__comments__container__reply-comment__info__caption__author{    \n    color: var(--primary-very-dark-color) !important;\n}\n\n.post-detail__comments__container__reply-comment__info__caption span{\n    /*font-weight: var(--font-bold);*/\n    color: var(--primary-very-dark-color);\n}\n\n.post-detail__comments__container__reply-comment-icon{\n    color: var(--primary-dark-color);\n    cursor: pointer;\n    \n}\n\n/* .post-detail__content__reply-comment__input{\n    border: 2px solid var(--mid-gray-color) !important;\n    margin-left: var(--space-x2);\n} */\n\n.post-detail__comments__container__comment__info__clapped-by__message span {}\n\n@media screen and ( max-width: 768px ) {\n\n    .post-detail {\n        margin: 0;\n        /* margin-top: var(--space); */\n        grid-template-areas: \"left\"\n                             \"center\";\n        grid-template-columns: 100%;\n        gap: var(--space-half);\n    }\n\n}\n\n.MuiPopover-root.post-detail__actions__action__menu-reactions .MuiListItem-root{\n    display: inline;\n}\n\n.MuiPopover-root.post-detail__actions__action__menu-reactions .MuiPaper-rounded{\n    border-radius: 34px;\n    padding-left: var(--space-half);\n    padding-right: var(--space-half);\n}\n\n.post-detail__actions__action__menu-reactions__icon{\n    font-size: var(--space-x3);\n    border-radius: 50%;\n}\n\n.post-detail__actions__action__menu-reactions__icon:hover{\n    font-size: calc(var(--space-x3) + var(--space-and-half));\n}\n\n.MuiPopover-root.post-detail__actions__action__menu-reactions .MuiListItem-gutters{\n    padding-left: var(--space-quarter);\n    padding-right: var(--space-quarter);\n    background: transparent;\n}\n\n.post-detail__actions__action__reactions__icon{\n    font-size: var(--space-x2);\n    margin-right: var(--space-half-quarter);\n}\n.post-detail__actions__action__comment-reactions__icon{\n    font-size: var(--space-and-half);\n    margin-right: var(--space-half-quarter);\n}\n\n.post-detail__actions__action__reaction-green.baloa-normal-medium{\n    color: #30B36B !important;\n    letter-spacing: 0 !important;\n    display: flex;\n    align-items: center;\n}\n\n.post-detail__actions__action__reaction-yellow.baloa-normal-medium{\n    color: #EECA35 !important;\n    letter-spacing: 0 !important;\n    display: flex;\n    align-items: center;\n} \n\n.post-detail__actions__action__reaction-red.baloa-normal-medium{\n    color: #EB3B3B !important;\n    letter-spacing: 0 !important;\n    display: flex;\n    align-items: center;\n}\n.post-detail__actions__action__reaction-green.baloa-table-column{\n    color: #30B36B !important;\n    letter-spacing: 0 !important;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.post-detail__actions__action__reaction-yellow.baloa-table-column{\n    color: #EECA35 !important;\n    letter-spacing: 0 !important;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n} \n\n.post-detail__actions__action__reaction-red.baloa-table-column{\n    color: #EB3B3B !important;\n    letter-spacing: 0 !important;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n.post-detail__actions__action{\n    display: flex;\n    align-items: center;    \n}\n\n.post-detail__actions__action .baloa-table-column{\n    color: var(--primary-dark-color);\n    cursor: pointer;\n}\n.post-detail__actions__action .icon-share, .post-detail__actions__action .icon-message, .post-detail__actions__action .icon-claps-48{\n    color: var(--primary-dark-color);\n    font-size: var(--space-and-half);\n    margin-right: var(--space-half-quarter);\n    cursor: pointer;\n}\n.post-detail__actions__action__action-text.baloa-normal-medium{\n    color: var(--primary-dark-color);\n}\n\n.post-detail__actions__action__list {\n    box-shadow: 2px 2px 5px 2px #4444;\n    padding: 0;\n    /* width: 15%; */\n    margin-top: calc(-1* calc(var(--space-x3)*2.2));\n    list-style: none;\n    position: absolute;\n    border-radius: 20px;\n}\n \n.post-detail__actions__action__list__button {\n    display: flex;\n    background-color: var(--white-color);\n    font-size: var(--space);\n    padding: var(--space-half-quarter) var(--space-and-half);\n    border: 0;\n    width: 100%;\n    outline: none;\n    cursor: pointer;\n    align-items: center;\n    border-radius: 20px;\n}\n\n.post-detail__actions__action__list__button:hover {\n    background-color: var(--primary-light-color);\n}\n.post-detail__separator{\n    border-top: 1px solid var(--separator-color);\n}\n\n.post-detail__comments__container__comment__info__resume{\n    width: 100%;\n    padding-top: var(--space-half-quarter);\n    padding-bottom: var(--space-half-quarter);\n    cursor: pointer;\n    align-items: center;\n}\n.post-detail__comments__container__comment__info__resume.baloa-names{\n    color: var(--primary-dark-color);   \n    display: flex;\n    justify-content: flex-start; \n}\n.post-detail__comments__container__comment-of-comment{\n    display: flex;\n    padding-bottom: var(--space);\n}\n\n.post-detail__comments__container__comment__info__resume__line-answers hr{\n    height:2px;\n    border-width:0;\n    color:#C5C5C5;\n    background-color:#C5C5C5;\n    width: var(--space-x2);\n    margin-right: var(--space-half);\n}\n\n@media screen and ( max-width: 375px ) {\n    .post-detail__header__info {\n        max-height: none;\n        flex-grow: 1;\n    }\n    .post-detail__header__photo{\n        height: auto;\n    }\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .post-detail {\n        margin: 0 var(--space) var(--space) var(--space);\n    }\n\n    .post-detail__actions__action{\n        flex-direction: column;\n    }\n\n    .post-detail__header__info__username__follow-link.baloa-hyperlink.mobile{\n        color: var(--basic-gray-color);\n    }\n\n    .post-detail__content__media{\n        margin:0;\n    }\n    .post-detail__actions__action .icon-share, .post-detail__actions__action .icon-message, .post-detail__actions__action .icon-claps-48 {\n        margin-right: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
